export default __webpack_public_path__ + "static/media/WrySmile.85f1b7d9.svg";